'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import { useQuery } from '@tanstack/react-query';
import { AuthQueryOptions } from '@/api';
import { Image } from '@/components/client';
import { closeResponsiveDialog } from '@/stores/ResponsiveDialogStore';
import { AttendanceCloverStrip } from '../attendance/_components/AttendanceCloverStrip';
import { mapAttendanceDaysToClover } from '../attendance/_utils/resolveCloverStrip';

/**
 * 데스크톱 모달은 셸 헤더(modalHeader)가 제목·설명·닫기(X)를 함께 렌더하지만,
 * 모바일 bottom drawer는 modalHeader를 무시하고 문자열 title만 받아 설명이 사라진다.
 * 그래서 문구를 여기 한 곳에 두고 시트(모바일)와 dialog 설정(데스크톱)이 같이 참조한다.
 */
export const ATTENDANCE_COMPLETE_COPY = {
  title: '오늘 출석 완료!',
  description: '7일 연속 방문 시 행운권 3배'
};

/**
 * 출석 완료 알림 시트(Figma 10665-50052). 자동 출석체크 성공 직후 열린다.
 * 사이클 진행도는 체크인 후 무효화가 끝난 캐시에서 읽으므로 첫 페인트부터 확정값이다.
 * 닫기(X)·좌우 패딩은 ResponsiveDialog 셸이 제공하므로 여기서 다시 두지 않는다.
 */
export const AttendanceCompleteSheet = () => {
  const $ = _c(8);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      ...AuthQueryOptions["get:/wello/v2/auth/benefit-attendance"](),
      select: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data: cloverDays
  } = useQuery(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex flex-col gap-12 xl:hidden"><h2 className="font-800 text-Gray-900 typo-h5">{ATTENDANCE_COMPLETE_COPY.title}</h2><p className="font-400 text-Gray-700 typo-body3">{ATTENDANCE_COMPLETE_COPY.description}</p></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Image alt="" src="/assets/pngs/attendance/daily-check-in.png" width={118} height={118} sizes="118px" className="size-118 shrink-0 object-contain" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== cloverDays) {
    t3 = <div className="flex flex-col items-center px-20 py-16">{t2}<div className="w-full"><AttendanceCloverStrip cloverDays={cloverDays} /></div></div>;
    $[3] = cloverDays;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Button className="w-full" onClick={closeResponsiveDialog}>확인</Button>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3) {
    t5 = <div className="flex flex-col gap-32 break-keep pb-20 xl:pb-0">{t1}{t3}{t4}</div>;
    $[6] = t3;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
function _temp(response) {
  return mapAttendanceDaysToClover(response.context?.days ?? []);
}